import { toPercent, formatNumber } from '@utils/Format'

const DEFAULT_VALUE = '-'

export const formatStatisticsCard = (stats) => {
  if (!stats) return buildEmptyCard()
  return {
    rent: formatRent(stats.inicio),
    vol: formatVol(stats.vol),
    sharpe: formatSharpe(stats.sharp_ratio, stats.vol),
  }
}

const buildEmptyCard = () => ({
  rent: DEFAULT_VALUE,
  vol: DEFAULT_VALUE,
  sharpe: DEFAULT_VALUE,
})

const formatRent = (rent) =>
  Number.isFinite(rent) ? toPercent(rent * 100) : DEFAULT_VALUE

const formatVol = (vol) =>
  Number.isFinite(vol) ? toPercent(vol * 100) : DEFAULT_VALUE

const formatSharpe = (sharpRatio, vol) =>
  vol ? formatNumber(sharpRatio) : DEFAULT_VALUE
